export default __webpack_public_path__ + "static/media/BTMA-Logo.2c50f768.webp";